<div class="card card-statistics mb-30" [hidden]="Form_Switcher!='List'" >
  <div class="card-body">
    <div class="float-left">
      <h5 class="card-title">
        انتخاب نامه مشتری جهت  برنامه ریزی
        <span *ngIf="Procssing_LetterRequestCustomer">(در حال دریافت اطلاعات ...)</span>
      </h5>
    </div>

    <div style="clear: both;"></div>
    <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing_LetterRequestCustomer" type="button" (click)="ReadData_Letter()"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> بروز رسانی </button>
      </div>
     </div>
    <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">نام مشتری</label>
        <input [(ngModel)]="Filter_CustomerName" name="Filter_CustomerName" type="text" class="form-control"
          placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> شماره نامه </label>
        <input [(ngModel)]="Filter_LetterCode" name="Filter_LetterCode" type="text" class="form-control"
          placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>

    </div>


    <div class="row">
      <div class="col-md-4 mb-30" *ngFor="let item of DataList_LetterRequestCustomer
            |filter:Filter_CustomerName:'customer'
            |filter:Filter_LetterCode:'code'
            | paginate
                    : {
                        id: 'DataList_UserTable',
                        itemsPerPage: 15,
                        currentPage: page,
                        totalItems: (DataList_LetterRequestCustomer
                        |filter:Filter_CustomerName:'customer'
                        |filter:Filter_LetterCode:'code'
                        ).length
                      }
            ">

        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title"> شماره نامه '{{item.code}}' </h5>
            <h6> {{item.customer}} </h6>
            <p> آدرس مشتری : {{item.giver_name}}  </p>
            <p> ماموریت های فعال : {{item.status}} مورد </p>
            <hr>
            <button style="margin-left: 5px;" (click)="On_Set_Form_Switcher('ScheduleForm',item)" class="btn btn-info"><i class="fa fa-id-badge"></i> برنامه ریزی </button>
            <a target="_blank" style="margin-left: 5px;" href="{{BaseUrl1}}{{item.id}}" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> نامه اعلام زمان </a>
            <button (click)="On_Set_Form_Switcher('Activity',item)" class="btn btn-warning"><i class="fa fa-wpforms"></i> وقایع </button>
          </div>
        </div>
      </div>
    </div>
    <pagination-controls id="DataList_UserTable"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<div  *ngIf="Form_Switcher=='ScheduleForm'">
  <app-ScheduleLetterForm [inner_Letter_record]="Selected_DataList_LetterRequestCustomer">

  </app-ScheduleLetterForm>
  <a target="_blank" style="margin-left: 5px;" href="{{BaseUrl1}}{{Selected_DataList_LetterRequestCustomer.id}}" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> نامه اعلام زمان </a>
  <a target="_blank" style="margin-left: 5px;" href="{{BaseUrl2}}{{Selected_DataList_LetterRequestCustomer.id}}" class="btn btn-info"><i class="fa fa-file-pdf-o"></i> نامه تجهیزات </a>
  <a target="_blank" style="margin-left: 5px;" href="{{BaseUrl3}}{{Selected_DataList_LetterRequestCustomer.id}}" class="btn btn-warning"><i class="fa fa-file-pdf-o"></i> نامه ماموریت </a>



  <button (click)="SwichActivityDevice(Selected_DataList_LetterRequestCustomer)" *ngIf="Selected_DataList_LetterRequestCustomer.dscVisible" type="button" class="btn btn-success" style="margin-left: 5px;">
    <i class="fa fa-eye"></i> نمایش ملاحظات در PDF
  </button>
  <button (click)="SwichActivityDevice(Selected_DataList_LetterRequestCustomer)" *ngIf="!Selected_DataList_LetterRequestCustomer.dscVisible" type="button" class="btn btn-danger" style="margin-left: 5px;">
    <i class="fa fa-eye-slash"></i>  عدم نمایش ملاحظات در PDF
  </button>

  <button (click)="SwichActivityVisible(Selected_DataList_LetterRequestCustomer)" *ngIf="Selected_DataList_LetterRequestCustomer.activityVisible" type="button" class="btn btn-success" style="margin-left: 5px;">
    <i class="fa fa-eye"></i> نمایش وقایع در PDF
  </button>
  <button (click)="SwichActivityVisible(Selected_DataList_LetterRequestCustomer)" *ngIf="!Selected_DataList_LetterRequestCustomer.activityVisible" type="button" class="btn btn-danger" style="margin-left: 5px;">
    <i class="fa fa-eye-slash"></i>  عدم نمایش وقایع در PDF
  </button>


  <button (click)="On_Back_Form_Switcher()" type="button" class="btn btn-warning" style="margin-right: 10px;"><i class="fa fa-mail-reply"></i> بازگشت </button>


</div>


<div class="card card-statistics mb-30" *ngIf="Form_Switcher=='Activity'">
  <div class="card-body">
    <div class="float-left">
      <h5 class="card-title">
        وقایع برای شماره نامه '{{Selected_DataList_LetterRequestCustomer.id}}'
      </h5>
    </div>
    
    <div style="clear: both;"></div>

    <app-LetterRequestCustomerMissionActivity
    [inner_Letter_id]="Selected_DataList_LetterRequestCustomer.id"
    [inner_Customer_id]="Selected_DataList_LetterRequestCustomer.customerId">

  </app-LetterRequestCustomerMissionActivity>

  <app-LetterRequestCustomerMissionActivityList
  [inner_Letter_id]="Selected_DataList_LetterRequestCustomer.id"
  [inner_Customer_id]="Selected_DataList_LetterRequestCustomer.customerId">

</app-LetterRequestCustomerMissionActivityList>

  <button (click)="On_Back_Form_Switcher()" type="button" class="btn btn-warning" style="margin-right: 10px;"><i class="fa fa-mail-reply"></i> بازگشت </button>

  </div>
</div>
